import React from 'react';
import Element from '../components/elements/element';

export default ({ chapter }) => {
  if (typeof chapter === 'undefined') {
    return <h1>404 | Chapter Not Found</h1>;
  }
  return <Element root={chapter} />;
};
